import { Instagram } from "lucide-react";
import { Link } from "wouter";
import { VowQuizLogo } from "@/components/icons/VowQuizLogo";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-[#EDEDED] bg-[#FAFAFA] py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-6">
          <div className="flex items-center text-xl font-serif text-gray-800">
            Vow Quiz <VowQuizLogo className="ml-2" width={40} height={40} />
          </div>

          <div className="flex gap-6 text-sm text-gray-600">
            {/* <Link
              href="/about"
              className="hover:text-pink-500 transition-colors"
            >
              About
            </Link> */}
            <Link
              href="/pricing"
              className="hover:text-pink-500 transition-colors"
            >
              Pricing
            </Link>
            <a
              href="mailto:hello@vowquiz.com"
              className="hover:text-pink-500 transition-colors"
            >
              Contact
            </a>
            <Link
              href="/privacy"
              className="hover:text-pink-500 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              className="hover:text-pink-500 transition-colors"
            >
              Terms of Service
            </Link>
          </div>

          <div className="flex gap-4">
            <a
              href="https://www.instagram.com/vowquiz"
              className="text-gray-600 hover:text-pink-500 transition-colors"
            >
              <Instagram className="h-5 w-5" />
            </a>
          </div>

          <div className="text-xs text-gray-500">
            © {new Date().getFullYear()} Wedding Quiz. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
